<template>
    <div>
      <el-row style="display: flex;margin-bottom: 10px;">
  
        <el-col>
          <el-button v-if="addYcVisitorQuestionTopicClass" @click="$form('addYcVisitorQuestionTopicClass')" size='small' type="primary"
            style="float:right" icon='el-icon-circle-plus'>添加拜访题目分类
          </el-button>
        </el-col>
      </el-row>
      <div>
        <myform :viewobj='{
          addYcVisitorQuestionTopicClass: ["新增拜访题目分类", "el-icon-circle-plus"],
          updateYcVisitorQuestionTopicClass: ["修改拜访题目分类", "el-icon-edit-outline"],
          $succeed$: getYcVisitorQuestionTopicClassList
        }' @confirm='myform' @close='$form("addYcVisitorQuestionTopicClass", "reset")'>
        
  
          <hide slot='yvqtcId' />
        </myform>
        <mytable :tableColums='tableColums_getYcVisitorQuestionTopicClassList' api='getYcVisitorQuestionTopicClassList'
          xupdateapi='updateOpportunityBusinessCheckImage' :height="H - 165">
        </mytable>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        theProjectId: 0,
        value: '',
        form: {
          projectId: '',
  
        },
        tableColums_getYcVisitorQuestionTopicClassList: {
          $selection: false,
  
          // oiType: '限制字段key',
  
          yvqtcName: '试题分类名称',
          yvqtcOrder: '排序',
         
  
          $operation: [
            '操作', 200,
            this.updateYcVisitorQuestionTopicClass && `@text: 编辑#success
               @click: $form("updateYcVisitorQuestionTopicClass",$this.row = $row)
              `,
            this.deleteYcVisitorQuestionTopicClass && `@text: 删除#danger
               @click: _confirm('确定要删除该填写项约束吗?')
                       .trigger('deleteYcVisitorQuestionTopicClass',{yvqtcId:$row.yvqtcId})
                       .trigger('getYcVisitorQuestionTopicClassList')
              `,
          ],
        }
      }
    },
    methods: {
      myform(submit, Myformdata) {
         submit();
      },
  
    },
    created() {
      this.getYcVisitorQuestionTopicClassList();
    },
  }
  </script>
  
  <style scoped></style>
  


// WEBPACK FOOTER //
// src/views/data/itemClassify.vue